import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import ChooseClient from './ChooseClient';
import Loading from './Loading';

const StartApp = ({ isChooseClient, onSelectedClient }) =>
    isChooseClient ? <ChooseClient onSelectedClient={onSelectedClient} /> : <Loading />;

StartApp.propTypes = {
    isChooseClient: PropTypes.bool.isRequired,
    onSelectedClient: PropTypes.func.isRequired,
};

export default pure(StartApp);
